import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
    state() {
        return {
            alertsChecked: false,
            urgentAlertContent: null,
        };
    },
    mutations,
    actions,
    getters,
};
